import Report, { MailSettings } from '../../../common/types/api/report'

const setMailSettings = (newProps: MailSettings, report: Report): Report => {
    return {
        ...report,
        mailSettings: {
            subject: newProps.subject,
            useCredits: newProps.useCredits,
            errorRecipients: newProps.errorRecipients,
            channels: newProps.channels,
            mailSettingsInstances: newProps.mailSettingsInstances,
            recipients: newProps.recipients
        }
    }
}

const getMailSettings = (report: Report): MailSettings => {
    return {
        ...report.mailSettings
    }
}
export { getMailSettings, setMailSettings }
